import { useEffect, useState } from 'react';
import { fetchSystemLinks } from '../services/api';

export const useBotLink = () => {
  const [botLink, setBotLink] = useState('');

  useEffect(() => {
    let isMounted = true;

    fetchSystemLinks()
      .then((links) => {
        if (!isMounted) return;
        setBotLink(links.bot || '');
      })
      .catch(() => { });

    return () => {
      isMounted = false;
    };
  }, []);

  return botLink;
};

